import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout__wrapper" }
const _hoisted_3 = { class: "article-single background-section" }
const _hoisted_4 = { class: "container article-single__content control-container" }

import Sidebar from '@/app/components/doc/reading/Sidebar.vue'
import HeaderBook from '@/app/components/doc/Header.vue'
import BackLink from '@/app/components/BackLink.vue'
import Footer from '@/app/components/Footer.vue'
import ReadingStreakNotification16464 from '@/app/components/streaks/ReadingStreakNotification16464.vue'

import PrevNext from './PrevNext.vue'
import ArticleThread from './Thread.vue'

import { ArticleView } from '@/models/doc.article'


export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
    article: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderBook, { doc: __props.article }, null, 8, ["doc"]),
    _createElementVNode("div", _hoisted_2, [
      (__props.article.completedStreakLength16464)
        ? (_openBlock(), _createBlock(ReadingStreakNotification16464, {
            key: 0,
            streakLength: __props.article.completedStreakLength16464
          }, null, 8, ["streakLength"]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BackLink, { class: "article-single__backlink" }),
          _createVNode(Sidebar, { doc: __props.article }, null, 8, ["doc"]),
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(PrevNext, { article: __props.article }, null, 8, ["article"]),
          _createVNode(ArticleThread, { article: __props.article }, null, 8, ["article"])
        ])
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})